export enum FeeTarget {
    Seller = 'Seller',
    Buyer = 'Buyer',
}
